import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface QuantitySectionProps {
  quantity: number;
  unit: string;
}

export default function QuantitySection({ quantity, unit }: Readonly<QuantitySectionProps>) {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5, fontSize: '0.875rem' }}>
        {t('offerDetail.quantity')}
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.primary' }}>
        {quantity} {unit}
      </Typography>
    </Box>
  );
}
